import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_CAMPAIGN_SUPPORTER_VOICES_SETTINGS = defineFcm('campaign_supporter_voices_settings')
	.asJson(
		createShapeNormalizer({
			type: 'object',
			shape: {
				minVideoSize: { type: 'number' },
				maxVideoSize: { type: 'number' },
				maxImageSize: { type: 'number' },
				// Note: Please update details file description for new properties added.
			},
		}),
	)
	.withDefault({
		minVideoSize: 0.04,
		maxVideoSize: 20,
		maxImageSize: 5,
	})
	.toConfig({
		owner: 'squad-capybara',
		scope: ['corgi-front-end', 'corgi-middle-end'],
		context: 'Supporter voices configuration on /p/:slug/actions page',
		description: `This creates a configuration file for various features and settings on the /p/:slug/actions page. It holds: 
 - maxVideoSize: video upload limit in megabytes 
 - maxImageSize: image upload limit in megabytes`,
		template: {
			minVideoSize: 0.04,
			maxVideoSize: 20,
			maxImageSize: 5,
		},
	});
